import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M13_TOPICS, M13_MODULE_INFO } from '../data/mathExercises/M13_Circles';

// Create mock problems data for M13
const M13_PROBLEMS_DATA = {
  'M13_01': [
    {
      id: 'M13_01_P001',
      topicId: 'M13_01',
      question: "圓的半徑為 5cm，求圓心角為 60° 的扇形面積",
      solution: "25π/6 cm²",
      explanation: "使用扇形面積公式計算",
      difficulty: 1,
      order: 1,
      steps: ["扇形面積 = (θ/360°) × πr²", "代入 θ = 60°, r = 5", "面積 = (60°/360°) × π × 25 = 25π/6 cm²"]
    },
    {
      id: 'M13_01_P002',
      topicId: 'M13_01',
      question: "半徑為 3 的圓中，弧長為 π 的弧所對應的圓心角是多少度？",
      solution: "60°",
      explanation: "利用弧長公式求圓心角",
      difficulty: 1,
      order: 2,
      steps: ["弧長公式：l = (θ/180°) × πr", "代入 l = π, r = 3", "π = (θ/180°) × π × 3，解得 θ = 60°"]
    }
  ],
  'M13_02': [
    {
      id: 'M13_02_P001',
      topicId: 'M13_02',
      question: "在圓中，弦 AB = 8，圓心到弦的距離為 3，求圓的半徑",
      solution: "r = 5",
      explanation: "利用弦與圓心距的關係",
      difficulty: 2,
      order: 1,
      steps: ["設圓心為 O，弦中點為 M", "OM ⊥ AB，AM = 4", "在直角三角形 OAM 中：r² = 3² + 4²", "r = 5"]
    }
  ],
  'M13_03': [
    {
      id: 'M13_03_P001',
      topicId: 'M13_03',
      question: "從圓外一點引兩條切線，切線長分別為 8 和 8，求證兩切線長相等",
      solution: "切線長相等",
      explanation: "圓的切線長定理",
      difficulty: 2,
      order: 1,
      steps: ["設圓外點為 P，切點為 A, B", "PA, PB 都是切線", "由切線長定理：PA = PB"]
    }
  ],
  'M13_04': [
    {
      id: 'M13_04_P001',
      topicId: 'M13_04',
      question: "在圓中，弧 AB 對應的圓周角為 30°，求圓心角的度數",
      solution: "圓心角為 60°",
      explanation: "圓周角定理：圓周角是圓心角的一半",
      difficulty: 1,
      order: 1,
      steps: ["圓周角定理：圓周角 = 圓心角 ÷ 2", "圓心角 = 圓周角 × 2", "圓心角 = 30° × 2 = 60°"]
    }
  ],
  'M13_05': [
    {
      id: 'M13_05_P001',
      topicId: 'M13_05',
      question: "兩弦 AB, CD 相交於圓內一點 P，若 PA = 3, PB = 4, PC = 2，求 PD",
      solution: "PD = 6",
      explanation: "相交弦定理：PA × PB = PC × PD",
      difficulty: 2,
      order: 1,
      steps: ["相交弦定理：PA × PB = PC × PD", "代入已知值：3 × 4 = 2 × PD", "12 = 2 × PD，所以 PD = 6"]
    }
  ],
  'M13_06': [
    {
      id: 'M13_06_P001',
      topicId: 'M13_06',
      question: "點 P 到圓心的距離為 5，圓的半徑為 3，判斷點與圓的位置關係",
      solution: "點在圓外",
      explanation: "比較點到圓心的距離與半徑",
      difficulty: 1,
      order: 1,
      steps: ["點到圓心距離 d = 5", "圓的半徑 r = 3", "因為 d > r，所以點在圓外"]
    }
  ],
  'M13_07': [
    {
      id: 'M13_07_P001',
      topicId: 'M13_07',
      question: "已知圓內接正六邊形的邊長為 a，求圓的半徑",
      solution: "r = a",
      explanation: "正六邊形的性質：邊長等於外接圓半徑",
      difficulty: 2,
      order: 1,
      steps: ["正六邊形可分為 6 個等邊三角形", "每個三角形的頂角為 60°", "邊長 = 半徑，所以 r = a"]
    }
  ]
};

const M13CirclesExercise = ({ onProgress }) => {
  // Convert problemsData to flat problems array
  const problems = Object.values(M13_PROBLEMS_DATA).flat();
  
  return (
    <ExerciseInterface
      moduleInfo={M13_MODULE_INFO}
      topics={M13_TOPICS}
      problems={problems}
      onProgress={onProgress}
      className="m13-exercise"
    />
  );
};

export default M13CirclesExercise; 